/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device and browser data — We may collect your IP address, browser type, operating system, and device identifiers for analytics and security purposes.`)
};

const es_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de dispositivo y navegador — Podemos recopilar tu dirección IP, tipo de navegador, sistema operativo e identificadores de dispositivo para propósitos de análisis y seguridad.`)
};

const de_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geräte- und Browserdaten — Wir können Ihre IP-Adresse, Ihren Browsertyp, Ihr Betriebssystem und Ihre Gerätekennungen für Analyse- und Sicherheitszwecke erfassen.`)
};

const nl_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaat- en browsergegevens — We kunnen uw IP-adres, browsertype, besturingssysteem en apparaat-ID's verzamelen voor analyse- en beveiligingsdoeleinden.`)
};

const fr_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données d’appareil et de navigateur — Nous pouvons collecter votre adresse IP, le type de navigateur, le système d’exploitation et les identifiants d’appareil à des fins d’analyse et de sécurité.`)
};

const it_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati dispositivo e browser — Potremmo raccogliere il tuo indirizzo IP, tipo di browser, sistema operativo e identificatori del dispositivo per scopi di analisi e sicurezza.`)
};

const pt_br2_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de dispositivo e navegador — Podemos coletar seu endereço IP, tipo de navegador, sistema operacional e identificadores de dispositivo para fins de análise e segurança.`)
};

const pt_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados do dispositivo e navegador — Podemos recolher o seu endereço IP, tipo de navegador, sistema operativo e identificadores de dispositivo para fins de análise e segurança.`)
};

const ja_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスおよびブラウザデータ — 分析とセキュリティの目的で、IPアドレス、ブラウザの種類、オペレーティングシステム、デバイス識別子を収集する場合があります。`)
};

const zh_privacy_info_device = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设备和浏览器数据 — 我们可能会收集您的IP地址、浏览器类型、操作系统和设备标识符，用于分析和安全目的。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_info_device = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_info_device(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_info_device", locale)
	if (locale === "en") return en_privacy_info_device(inputs)
	if (locale === "es") return es_privacy_info_device(inputs)
	if (locale === "de") return de_privacy_info_device(inputs)
	if (locale === "nl") return nl_privacy_info_device(inputs)
	if (locale === "fr") return fr_privacy_info_device(inputs)
	if (locale === "it") return it_privacy_info_device(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_info_device(inputs)
	if (locale === "pt") return pt_privacy_info_device(inputs)
	if (locale === "ja") return ja_privacy_info_device(inputs)
	return zh_privacy_info_device(inputs)
};